import { createContext, useEffect, useState } from "react";
import decodeToken from "../utils/decodeToken";

export const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthLoading, setIsAuthLoading] = useState(true);

  useEffect(() => {
    try {
      const storedUser = localStorage.getItem("@aqvex/user");
      const storedToken = localStorage.getItem("@aqvex/token");

      if (storedUser && storedToken) {
        const payload = decodeToken(storedToken);
        const isExpired = payload?.exp && Date.now() / 1000 > payload.exp;

        if (isExpired) {
          localStorage.removeItem("@aqvex/user");
          localStorage.removeItem("@aqvex/token");
        } else {
          setUser({
            token: storedToken,
            info: JSON.parse(storedUser),
          });
        }
      }
    } catch {
      setUser(null);
    } finally {
      setIsAuthLoading(false);
    }
  }, []);

  useEffect(() => {
    const handleExpired = () => setUser(null);
    window.addEventListener("auth:expired", handleExpired);
    return () => window.removeEventListener("auth:expired", handleExpired);
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, isAuthLoading }}>
      {children}
    </AuthContext.Provider>
  );
};
